(function() {
  'use strict';

  angular.module('ringbaPortal').component('targetTypeToggle', {
    bindings: {
      callType: '<',
      onChange: '&'
    },
    controller: TargetTypeToggleController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/target-type-toggle/target-type-toggle.view.html'
  });

  function TargetTypeToggleController() {
    'ngInject';
  }
})();
